import React, { useRef } from 'react';
import {inject, observer} from 'mobx-react';

import {
    getLLWidgetList,
    LLPreloader,
} from '../../../../../components';
import { HomeCarousel } from '../../../../home/components';


const MiniBanners = ({store}) => {

    const getWidgetsByZones = store.user.widgets.llWidget.getWidgetsByZones,
        widgetsLoading = store.user.widgets.llWidget.isFetching,
        viewSize = store.site.status.viewSize;

    const banners = getLLWidgetList(
        getWidgetsByZones('mini-banner', viewSize),
        'mini-banner'
    );

    const bannersSliderRef = useRef(null);

    const renderBanners = () => (
        banners?.length ? (
            <HomeCarousel
                homeSlides={banners}
                speed={1000}
                delay={3000}
                sliderRef={bannersSliderRef}
                autoplay={true}
                sliderHeight={'400px'}
                className={
                    'games__header-banner games__header-banner-slider home-page__banner-slider'
                }
            />
        ) : null);

    return (
        <div className="mini-banners">
            {widgetsLoading ? <LLPreloader height={50} width={50} /> : renderBanners()}
        </div>
    );
};

export default inject('store')(observer(MiniBanners));
